"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _youtubeRegex = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
var _list = [_youtubeRegex];

function checkIfYoutube(url) {
  var found = url.match(_youtubeRegex);
  return found !== null;
}

exports.checkIfYoutube = checkIfYoutube;

function getYoutubeId(url) {
  return url.match(_youtubeRegex) ? RegExp.$1 : null;
}

exports.getYoutubeId = getYoutubeId;

function convertToYoutubeEmbed(url) {
  var id = getYoutubeId(url);
  return "https://www.youtube.com/embed/".concat(id);
}

exports.convertToYoutubeEmbed = convertToYoutubeEmbed;

function checkIfPreview(url) {
  if (url === null) {
    return false;
  }

  if (checkIfYoutube(url)) {
    return true;
  }

  return false;
}

exports.checkIfPreview = checkIfPreview;